import React, { useState, useEffect, useRef } from "react";
import useSession from "Utils/Hooks/useSession";
import { PlaidLink } from "react-plaid-link";
import useVipApiFetcher from "Utils/Hooks/useVipApiFetcher";
import { useHistory } from "react-router-dom";
import useMode, { MODE } from "Utils/Hooks/useMode";
import useRedirectUrl from "Utils/Hooks/useRedirectUrl";
import VIPOnlineLogo from "Assets/Img/vipo-logo.png";
import bankIcon from 'Assets/Icons/bank.svg';
import Loading from "Components/Loading";
import { Button } from "react-bootstrap";
import useNative from "Utils/Hooks/useNative";
import useOAuthStateId from "Utils/Hooks/useOAuthStateId";
import useAppKey from "Utils/Hooks/useAppKey";
import AddFundingSourceError from "Assets/Img/AddFundingSourceError.png";
import "./OnlineEnrollment.scss";
const OnlineEnrollment = (props) => {
    const vipApi = useVipApiFetcher();
    const mode = useMode();
    const { session, fetchSession, updateSession } = useSession();
    const [linkToken, setLinkToken] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [divStyle, setDivStyle] = useState({ display: 'none' });
    const history = useHistory();
    const isNative = useNative();
    const oauth_state_id = useOAuthStateId();
    const navigateToDeposit = mode === MODE.deposit;
    const navigateToWithdraw = mode === MODE.withdraw;
    const [receivedRedirectUri, setReceivedRedirectUri] = useState(null);
    const url = useRedirectUrl();
    const appKey = useAppKey();
    const refTimeOut = useRef(false);
    const [mitekRedirect, setMitekRedirect] = useState(session?.mitekValidationStage !== 'None' ? true : false);
    const mitekLink = session?.mitekValidationStage !== 'None' ? session?.mitekLink : null;

    const style = {
        width: '100%',
        height: '66vh',
        overflow: 'hidden',
        border: 'none',
        align: 'center'
    };

    useEffect(() => {
        const poll = async function (ms) {
            let result = await vipApi.fetch("/api/mitek/status");
            while (result.status === 202 && !refTimeOut.current) {
                updateSession(await result.json());
                await wait(ms);
                result = await vipApi.fetch("/api/mitek/status");
            }
            return result;
        };

        const wait = function (ms = 5000) {
            return new Promise(resolve => {
                setTimeout(resolve, ms);
            });
        };
        async function fetchData() {
            if (mitekRedirect) {
                setIsLoading(false);
                const responseCode = await poll(10000);
                if (responseCode.status === 200 && !refTimeOut.current) {
                    setMitekRedirect(false);
                    loadHandler();
                }
                else {
                    onEnrollError();
                }
            }
        }
        fetchData();
    }, [mitekRedirect]);

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data === "timeout") {
                refTimeOut.current = true;
            }
        };
        window.addEventListener('message', handleMessage);

        if (props.plaidRedirect) {
            setLinkToken(localStorage.getItem("link_token"));
            setReceivedRedirectUri(url ? url + "?oauth_state_id=" + oauth_state_id : (window.location.href.includes('oauth_state_id=') ? window.location.href : window.location.href + "?oauth_state_id=" + oauth_state_id));
            // setReceivedRedirectUri("https://cdn.plaid.com/link/v2/stable/oauth.html?oauth_state_id=" + oauth_state_id);
            setIsLoading(false);
        }

        if (!props.plaidRedirect) {
            let mounted = true;
            let oprUrl = '';
            if (url) {
                oprUrl = appKey ? "?redirectUri=" + url + "/" + appKey : "?redirectUri=" + url;
            }
            else {
                oprUrl = appKey ? "?redirectUri=" + window.location.href + "/" + appKey : "?redirectUri=" + window.location.href + "/" + session.merchantId;
            }
            vipApi.fetch("/api/plaid/link" + oprUrl)
                .then((res) => {
                    res.json().then((data) => {
                        if (!mounted) return;
                        if (res.ok) {
                            setLinkToken(data.linkToken);
                            localStorage.setItem("link_token", data.linkToken);
                        }
                        setIsLoading(false);
                    });
                })
                .catch((error) => {
                    console.error(error);
                    onEnrollError();
                });
            return () => { mounted = false; };
        }
        return () => { window.removeEventListener('message', handleMessage); };
    }, []);


    const openNativeLink = () => {
        window.$onAndroidSuccess = function (metadata) {
            onAndroidSuccess(metadata);
        }

        window.$onAndroidError = function (error) {
            onAndroidError(error);
        }
        let message = {
            linkToken: linkToken
        };

        var plaidTokenForAndroid = linkToken;
        if (/android/i.test(navigator.userAgent) || window?.Android) {
            handleAndroidMessage(plaidTokenForAndroid);
        }
        if (/iPad|iPhone|iPod/.test(navigator.userAgent) || window?.webkit) {
            var iosPromise = window?.webkit?.messageHandlers?.NativeBridge?.postMessage(message);
            iosPromise.then(
                function (result) {
                    onSuccessDefault(null, result);
                },
                function (err) {
                    console.log(err);
                })
                .finally(() => {
                    //iosPromise.dispose();
                });
        }
    };

    function handleAndroidMessage(message) {
        return new Promise((resolve, reject) => {
            window?.Android?.openLinkNative(message, onAndroidSuccess.name, onAndroidError.name);
        });
    }

    function onAndroidSuccess(metadata) {
        console.log("onAndroidSuccess called");
        console.log(metadata);
        onSuccessDefault(null, metadata);
    }

    function onAndroidError(error) {
        console.log("onAndroidError called");
        console.log(error);
    }

    const onSuccessDefault = (_, metadata) => {
        setIsLoading(true);
        vipApi.fetch("/api/plaid/account", "PUT", {
            accountId: metadata.account_id,
            accountToken: metadata.public_token
        })
            .then((res) => res.json())
            .then((data) => {
                onSubmitCommon();
            })
            .catch((err) => {
            });
    };

    const onSubmitCommon = async (url = "/api/plaid/enroll") => {
        setSubmitted(true);
        const response = await vipApi.fetch(url, "POST");
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const body = await response.json();
            if (body.status) {
                if (body.status === "success") {
                    onEnrollSuccess();
                }
                else {
                    onEnrollError();
                }
            }
            else {
                onEnrollError();
            }
        } else {
            onEnrollError();
        }
        localStorage.removeItem("link_token");
    };

    async function onEnrollSuccess() {
        // Fetch updated session data - should now show as enrollment complete.
        await fetchSession(true);
        setSubmitted(false);
        history.push({
            pathname: "/submit",
            state: {
                isEnrollment: true,
                isSuccess: true,
                isError: false,
                title: "Account Created",
                message:
                    "Your VIP account has been created and you are now able to make transactions.",
                navigateTo: navigateToDeposit
                    ? "addFunds"
                    : navigateToWithdraw
                        ? "withdrawFunds"
                        : "dashboard",
            },
        });
    }

    function onEnrollError() {
        setSubmitted(false);
        history.push({
            pathname: '/submit',
            state: {
                isEnrollment: true,
                isSuccess: false,
                isError: true,
                title: "Account Not Created",
                message: `Your account cannot be created at this time. Please call CAMS for assistance at 1-800-500-1973, or try a different payment method on the ${session.operatorName.toUpperCase()} website.`,
                buttonText: `CONTINUE TO ${session.operatorName.toUpperCase()}`
            }
        });
    }

    const onExit = (error, metadata) => {
        window.sessionStorage.setItem("plaidlaunch", false);
        setDivStyle({ display: 'block' });
        console.log(error, metadata);
    };

    const showDiv = {
        display: 'block'
    }


    const loadHandler = () => {
        window.sessionStorage.setItem("plaidlaunch", true);
        if (true) {
            const open = document.getElementsByClassName("ready")[0];
            open.click();
            if (!props.plaidRedirect) {
                setIsLoading(false);
            }
        }
    };

    let button;

    if (isLoading) {
        button = <Loading />;
    }
    else {
        button = !isNative ?
            <div style={divStyle}>
                <PlaidLink token={linkToken} onSuccess={onSuccessDefault} onExit={onExit} className="ready" onLoad={loadHandler}>
                    <img className="bank-icon  click-add-plaid" src={bankIcon} alt="Bank Icon"></img><div className="bank-label click-add-plaid">CONNECT YOUR BANK ACCOUNT</div>
                </PlaidLink>
            </div>
            :
            <Button className="ready" onClick={openNativeLink}><img className="bank-icon click-add-plaid" src={bankIcon} alt="Bank Icon"></img><div className="bank-label click-add-plaid">CONNECT YOUR BANK ACCOUNT</div></Button>
    }

    let plaidFundingSourceError = <>
        <div className="enrollment-header">
            <img className="vip-preferred" src={VIPOnlineLogo} alt="VIP Online"></img>
            <br />
            <span className="title">Account Sign Up</span>
        </div>
        <div style={{ 'width': '100%', 'display': 'inline-block', 'textAlign': 'center' }}>
            <div className="add-funding-source-error" style={{ 'width': '60%', 'display': 'inline-block', 'textAlign': 'center' }}>
                <img src={AddFundingSourceError} alt='Add Funding Source Error' style={{ 'paddingTop': '5px', 'paddingBottom': '10px' }}></img>
                <p>We are unable to add new accounts at this time.</p>
            </div>
        </div></>;

    return (
        <>
            {props.plaidRedirect && <PlaidLink token={linkToken} onSuccess={onSuccessDefault} className="ready" onLoad={loadHandler} receivedRedirectUri={receivedRedirectUri} onExit={onExit}>
            </PlaidLink>}
            {isLoading ? <Loading></Loading> : <>
                <div style={!(mitekRedirect || isNative) ? divStyle : showDiv}>
                    <div className="enrollment-header">
                        <img className="vip-preferred" src={VIPOnlineLogo} alt="VIP Online"></img>
                        <br />
                        <span className="title">Account Sign Up</span>
                    </div>
                </div>
                {mitekRedirect ? <div style={style}>
                    <iframe src={mitekLink} allow="autoplay; camera; microphone" title="Verification Process" style={style} />
                </div> : <div className="funding-source">
                    {linkToken && button}
                    {!linkToken && plaidFundingSourceError}
                </div>
                }</>}
        </>
    );
};
export default OnlineEnrollment;